export const HOME = {
  emergentLink: "home-emergent-link",
  heroBanner: "home-hero-banner",
  productGrid: "home-product-grid",
  emptyState: "home-empty-state",
  searchInput: "home-search-input",
  categoryFilter: (cat) => `home-category-${cat.toLowerCase()}`,
  productCard: (id) => `product-card-${id}`,
  buyNowBtn: (id) => `buy-now-btn-${id}`,
};

export const CHECKOUT = {
  modal: "checkout-modal",
  closeBtn: "checkout-close-btn",
  nameInput: "checkout-name-input",
  phoneInput: "checkout-phone-input",
  addressInput: "checkout-address-input",
  pincodeInput: "checkout-pincode-input",
  submitBtn: "checkout-submit-btn",
  successScreen: "checkout-success-screen",
};

export const ADMIN = {
  passwordInput: "admin-password-input",
  unlockBtn: "admin-unlock-btn",
  passwordError: "admin-password-error",
  logoutBtn: "admin-logout-btn",
  maintenanceSwitch: "admin-maintenance-switch",
  titleInput: "admin-title-input",
  priceInput: "admin-price-input",
  categorySelect: "admin-category-select",
  descriptionInput: "admin-description-input",
  imageInput: "admin-image-input",
  addProductBtn: "admin-add-product-btn",
  tabProducts: "admin-tab-products",
  tabOrders: "admin-tab-orders",
  productRow: (id) => `admin-product-row-${id}`,
  deleteProductBtn: (id) => `admin-delete-product-${id}`,
  orderRow: (id) => `admin-order-row-${id}`,
};
